module.exports = __webpack_public_path__ + "static/media/shadowimage.0acfbdd4.png";